// import PropTypes from "prop-types";
// import MailchimpSubscribe from "react-mailchimp-subscribe";

// const CustomForm = ({ status, message, onValidated }) => {
//   let email;
//   const submit = () => {
//     email &&
//       email.value.indexOf("@") > -1 &&
//       onValidated({
//         EMAIL: email.value
//       });

//     let emailInput = document.getElementById("mc-form-email");
//     emailInput.value = "";
//   };

//   return (
//     <div className="subscribe-form">
//       <div className="mc-form">
//         <div>
//           <input
//             id="mc-form-email"
//             className="email"
//             ref={node => (email = node)}
//             type="email"
//             placeholder="Enter your email address..."
//           />
//         </div>
//         <div className="clear">
//           <button className="button" onClick={submit}>
//             SUBSCRIBE
//           </button>
//         </div>
//       </div>

//       {status === "sending" && (
//         <div style={{ color: "#3498db", fontSize: "12px" }}>sending...</div>
//       )}
//       {status === "error" && (
//         <div
//           style={{ color: "#e74c3c", fontSize: "12px" }}
//           dangerouslySetInnerHTML={{ __html: message }}
//         />
//       )}
//       {status === "success" && (
//         <div
//           style={{ color: "#2ecc71", fontSize: "12px" }}
//           dangerouslySetInnerHTML={{ __html: message }}
//         />
//       )}
//     </div>
//   );
// };

// const SubscribeEmail = ({ mailchimpUrl }) => {
//   return (
//     <div>
//       <MailchimpSubscribe
//         url={mailchimpUrl}
//         render={({ subscribe, status, message }) => (
//           <CustomForm
//             status={status}
//             message={message}
//             onValidated={formData => subscribe(formData)}
//           />
//         )}
//       />
//     </div>
//   );
// };

// SubscribeEmail.propTypes = {
//   mailchimpUrl: PropTypes.string
// };

// export default SubscribeEmail;


import PropTypes from "prop-types";
import { useState } from "react";
import axios from "axios";
import { API_ENDPOINT, GlOBAL_SUBSCRIBER } from "../../../config";

const SubscribeEmail = ({ apiUrl }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(""); // "sending", "success", "error"
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    if (!email || email.indexOf("@") === -1) {
      setStatus("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    setStatus("sending");
    try {
      const response = await axios.post(`${API_ENDPOINT}${GlOBAL_SUBSCRIBER}`, { email });
      if (response.status === 200) {
        setStatus("success");
        setMessage("Thank you for subscribing!");
        setEmail(""); // Clear the email field
      } else {
        setStatus("error");
        setMessage(response.message);
      }
    } catch (error) {
      setStatus("error");
      // console.log("error",error)
      setMessage(error.response.data.message);
    }
  };

  return (
    <div className="subscribe-form">
      <div className="mc-form">
        <div>
          <input
            id="mc-form-email"
            className="email"
            type="email"
            placeholder="Enter your email address..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="clear">
          <button className="button" onClick={handleSubmit}>
            SUBSCRIBE
          </button>
        </div>
      </div>

      {status === "sending" && (
        <div style={{ color: "#3498db", fontSize: "12px" }}>Sending...</div>
      )}
      {status === "error" && (
        <div style={{ color: "#e74c3c", fontSize: "12px" }}>{message}</div>
      )}
      {status === "success" && (
        <div style={{ color: "#2ecc71", fontSize: "12px" }}>{message}</div>
      )}
    </div>
  );
};

SubscribeEmail.propTypes = {
  apiUrl: PropTypes.string.isRequired,
};

export default SubscribeEmail;
